import { render, staticRenderFns } from "./NoaNotesWidget.vue?vue&type=template&id=28b63782"
import script from "./NoaNotesWidget.vue?vue&type=script&lang=js"
export * from "./NoaNotesWidget.vue?vue&type=script&lang=js"
import style0 from "./NoaNotesWidget.vue?vue&type=style&index=0&id=28b63782&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports